import React from 'react';
import { Scale, FileSignature, GitPullRequest, TrendingUp, Lock } from 'lucide-react';

const Governance = () => {
  return (
    <section id="governance" className="py-24 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start mb-16">
          <div className="md:w-1/2">
            <h2 className="text-3xl font-bold mb-6">Governance & Standards</h2>
            <p className="text-slate-300 text-lg leading-relaxed">
              InternStacks operates under defined contributor agreements and documented project policies. The ecosystem is built on accountability, not informality.
            </p>
          </div>
          <div className="mt-8 md:mt-0">
             <div className="inline-block p-4 border border-slate-700 rounded bg-slate-800/50">
                <p className="text-sm text-slate-400 font-mono">STATUS: GOVERNED ECOSYSTEM</p>
                <p className="text-sm text-slate-400 font-mono">ENFORCEMENT: ACTIVE</p>
             </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
                { icon: FileSignature, text: "All contributors work under formal IP and participation agreements." },
                { icon: GitPullRequest, text: "Project architecture is mentor-controlled and version-locked." },
                { icon: Scale, text: "Quality thresholds are enforced strictly before merge." },
                { icon: TrendingUp, text: "Reputation progression is performance-based, never automatic." },
                { icon: Lock, text: "Participation is structured and audited, not symbolic." }
            ].map((item, i) => (
                <div key={i} className="flex items-start p-6 bg-slate-800/30 border border-slate-700 rounded-sm hover:bg-slate-800 transition-colors">
                    <item.icon className="w-6 h-6 text-emerald-400 mt-1 mr-4 shrink-0" />
                    <p className="text-slate-300">{item.text}</p>
                </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Governance;
